define("shared/errors/invalid-credentials-error", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  class InvalidCredentialsError extends Error {
    constructor() {
      let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Invalid Social Network Credentials';
      super(message);
      this.name = 'InvalidCredentialsError';
    }
  }
  _exports.default = InvalidCredentialsError;
});